import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from 'components/Box'
import Text from 'components/Text'

import { Notification } from 'types/global'
import { QuotationChangedStatus } from 'services/types/notification'

import { Highlight } from './styles'
import NotificationHeader from './NotificationHeader'
import NotificationFooter from './NotificationFooter'

interface IProps extends Notification {
  data: QuotationChangedStatus
}

const QuotationApproval: React.FC<IProps> = ({ data, ...restProps }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" paddingLeft="10px" width="100%" flexDirection="column">
      <NotificationHeader {...restProps} title="quotation_approval" />
      <Box display="flex" paddingTop="4px">
        <Text lineHeight="22px">
          <span>{t('Lead')}</span>
          <Highlight>{data.lead_name}</Highlight>
          <span>{data.message}</span>
        </Text>
      </Box>
      <NotificationFooter {...restProps} />
    </Box>
  )
}

export default QuotationApproval
